import React, { useState } from 'react';
import {
    FormControl,
    Typography,
    Button,
    TextField,
    Checkbox,
    FormControlLabel,
    Box,
    Paper,
} from '@mui/material';
import DataTable from '../../Requirement/components/common/ReusableTable';

const tableData = [
  {
    "sl_no": 1,
    "role_name": "Buyer-Admin",
    "permission": "Full Access (Users, RFQs, Settings)",
    "status": "Active",
    "created_on": "2022-01-01"
  },
  {
    "sl_no": 2,
    "role_name": "Buyer Tread User",
    "permission": "View RFQs, Create RFQs",
    "status": "Active",
    "created_on": "2022-02-15"
  },
  {
    "sl_no": 3,
    "role_name": "Buyer Finance User",
    "permission": "View Invoices, Manage Payments",
    "status": "Active",
    "created_on": "2022-03-10"
  },
  {
    "sl_no": 4,
    "role_name": "Supplier-Admin",
    "permission": "Full Access (Users, Offers, Settings)",
    "status": "Active",
    "created_on": "2022-04-20"
  },
  {
    "sl_no": 5,
    "role_name": "Supplier Tread User",
    "permission": "View Offers, Submit Offers",
    "status": "Active",
    "created_on": "2022-05-05"
  }
];

const columns = [
    { id: "sl_no", numeric: false, label: "SL.NO" },
    { id: "role_name", numeric: false, label: "ROLE NAME" },
    { id: "permission", numeric: false, label: "PERMISSION" },
    {
        id: "status",
        numeric: false,
        label: "STATUS",
        renderCell: (row) => {
            let bgColor = "";
            let textColor = "";

            switch (row.status) {
                case "Pending":
                    bgColor = "#fef3c7";
                    textColor = "#b45309";
                    break;
                case "Active":
                    bgColor = "#d1fae5";
                    textColor = "#065f46";
                    break;
                case "Inactive":
                    bgColor = "#fee2e2";
                    textColor = "#991b1b";
                    break;
                default:
                    bgColor = "#f3f4f6";
                    textColor = "#374151";
            }

            return (
                <span
                    style={{
                        backgroundColor: bgColor,
                        color: textColor,
                        padding: "4px 10px",
                        borderRadius: "999px",
                        fontSize: "0.75rem",
                        fontWeight: 500,
                    }}
                >
                    {row.status}
                </span>
            );
        },
    },
    { id: "created_on", numeric: false, label: "CREATED ON" },
];

const BuyerRolePermission = () => {
    const [formData, setFormData] = useState({
        roleName: '',
        permissions: {
            courseGroupMaster: { add: false, edit: false, delete: false, view: false, search: false },
            courseMaster: { add: false, edit: false, delete: false, view: false, search: false },
            centreMaster: { add: false, edit: false, delete: false, view: false, search: false },
        },
    });

    const [errors, setErrors] = useState({
        roleName: '',
    });

    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const handlePermissionChange = (feature, permission, checked) => {
        setFormData((prev) => ({
            ...prev,
            permissions: {
                ...prev.permissions,
                [feature]: {
                    ...prev.permissions[feature],
                    [permission]: checked,
                },
            },
        }));
    };

    const handleAdd = () => {
        if (isFormVisible && !isEditMode) {
            setIsFormVisible(false);
        } else {
            setFormData({
                roleName: '',
                permissions: {
                    courseGroupMaster: { add: false, edit: false, delete: false, view: false, search: false },
                    courseMaster: { add: false, edit: false, delete: false, view: false, search: false },
                    centreMaster: { add: false, edit: false, delete: false, view: false, search: false },
                },
            });
            setErrors({
                roleName: '',
            });
            setIsEditMode(false);
            setIsFormVisible(true);
        }
    };

    const handleRowClick = (row) => {
        setIsEditMode(true);
        setIsFormVisible(true);
        setFormData({
            roleName: row.role_name,
            permissions: {
                courseGroupMaster: { add: false, edit: false, delete: false, view: false, search: false }, // Placeholder; adjust based on actual permission data
                courseMaster: { add: false, edit: false, delete: false, view: false, search: false },     // Placeholder; adjust based on actual permission data
                centreMaster: { add: false, edit: false, delete: false, view: false, search: false },     // Placeholder; adjust based on actual permission data
            },
        });
        setErrors({
            roleName: '',
        });
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = { roleName: '' };

        if (!formData.roleName.trim()) {
            newErrors.roleName = 'Role Name is required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        console.log('Submitted Form Data:', formData);
        setIsFormVisible(false);
    };

    return (
        <div className="container">
            <Paper elevation={2} sx={{ p: 3 }}>
                <div className="table-header">
                    <div className="header-text">
                        <div className="head-text">Roles & Permissions</div>
                        <div className="head-subtext" style={{ color: '#666' }}>
                            Manage user roles and their associated permissions.
                        </div>
                    </div>
                    <div className="submit-btn-form">
                        <button className="submit-btn-more" onClick={handleAdd}>
                            {isFormVisible ? (isEditMode ? "Cancel" : "Cancel") : "Add New Role"}
                        </button>
                    </div>
                </div>
                <div className="table-content">
                    <DataTable
                        columns={columns}
                        data={tableData}
                        onRowClick={handleRowClick}
                    />
                </div>

                {isFormVisible && (
                    <div className='raise-ticket'>
                        <div className="table-header">
                            <div className="header-text">
                                <div className="head-subtext">
                                    {isEditMode ? "Update role details." : "Fill in the details below to create a new role."}
                                </div>
                            </div>
                            <div className="head-btn">
                                <div className="submit-btn-form">
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row gx-3">
                                <FormControl className="col-md-12 mb-3" required sx={{ pr: 1 }}>
                                    <Typography variant="body2" gutterBottom>
                                        Role Name *
                                    </Typography>
                                    <TextField
                                        name="roleName"
                                        value={formData.roleName}
                                        onChange={handleChange}
                                        placeholder="Enter role name"
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        required
                                        error={!!errors.roleName}
                                        helperText={errors.roleName}
                                    />
                                </FormControl>

                                <FormControl className="col-md-12 mb-3" sx={{ pl: 1, display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="body2" gutterBottom>
                                        Manage Permissions
                                    </Typography>
                                    <FormControlLabel
                                        control={<Checkbox onChange={(e) => {
                                            const checked = e.target.checked;
                                            setFormData((prev) => ({
                                                ...prev,
                                                permissions: {
                                                    courseGroupMaster: { add: checked, edit: checked, delete: checked, view: checked, search: checked },
                                                    courseMaster: { add: checked, edit: checked, delete: checked, view: checked, search: checked },
                                                    centreMaster: { add: checked, edit: checked, delete: checked, view: checked, search: checked },
                                                },
                                            }));
                                        }} />}
                                        label="Select All"
                                    />
                                    <Box sx={{ mt: 2 }}>
                                        {/* <Typography variant="subtitle2" gutterBottom>
                                            FEATURES/MENU
                                        </Typography> */}
                                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                                            <thead>
                                                <tr>
                                                    <th  style={{ padding: '8px !important', borderBottom: '1px solid #ddd' }}>FEATURES/MENU</th>
                                                    <th style={{ padding: '8px !important', borderBottom: '1px solid #ddd' }}>ADD</th>
                                                    <th style={{ padding: '8px !important', borderBottom: '1px solid #ddd' }}>EDIT</th>
                                                    <th style={{ padding: '8px !important', borderBottom: '1px solid #ddd' }}>DELETE</th>
                                                    <th style={{ padding: '8px !important', borderBottom: '1px solid #ddd' }}>VIEW</th>
                                                    <th style={{ padding: '8px !important', borderBottom: '1px solid #ddd' }}>SEARCH</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Course Group Master</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseGroupMaster.add}
                                                            onChange={(e) => handlePermissionChange('courseGroupMaster', 'add', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseGroupMaster.edit}
                                                            onChange={(e) => handlePermissionChange('courseGroupMaster', 'edit', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseGroupMaster.delete}
                                                            onChange={(e) => handlePermissionChange('courseGroupMaster', 'delete', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseGroupMaster.view}
                                                            onChange={(e) => handlePermissionChange('courseGroupMaster', 'view', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseGroupMaster.search}
                                                            onChange={(e) => handlePermissionChange('courseGroupMaster', 'search', e.target.checked)}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Course Master</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseMaster.add}
                                                            onChange={(e) => handlePermissionChange('courseMaster', 'add', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseMaster.edit}
                                                            onChange={(e) => handlePermissionChange('courseMaster', 'edit', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseMaster.delete}
                                                            onChange={(e) => handlePermissionChange('courseMaster', 'delete', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseMaster.view}
                                                            onChange={(e) => handlePermissionChange('courseMaster', 'view', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.courseMaster.search}
                                                            onChange={(e) => handlePermissionChange('courseMaster', 'search', e.target.checked)}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Centre Master</td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.centreMaster.add}
                                                            onChange={(e) => handlePermissionChange('centreMaster', 'add', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.centreMaster.edit}
                                                            onChange={(e) => handlePermissionChange('centreMaster', 'edit', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.centreMaster.delete}
                                                            onChange={(e) => handlePermissionChange('centreMaster', 'delete', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.centreMaster.view}
                                                            onChange={(e) => handlePermissionChange('centreMaster', 'view', e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>
                                                        <Checkbox
                                                            checked={formData.permissions.centreMaster.search}
                                                            onChange={(e) => handlePermissionChange('centreMaster', 'search', e.target.checked)}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </FormControl>
                            </div>
                        </form>
                    </div>
                )}
            </Paper>
        </div>
    );
};

export default BuyerRolePermission;